import { html, SYSFormElement } from "../../../../_ovlclient/src"
import type { DialogHolderParams } from "../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  FieldIsValid,
  FieldIsValidSelective,
} from "../../../../_ovlclient/src/library/forms/fieldapi"
import { FormIsLocked } from "../../../../_ovlclient/src/library/forms/formapi"
import { ProcessIsRunning } from "../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

import { T } from "../../../../_ovlclient/src/textapi"

import { SYSLogin } from "./allactions"

export type LoginFormState = {}

export type FieldId = "pw" | "user"

type TOTPAuthReturn = {
  TOTPRequestKey: string
  TOTPSetupManualKey: string
  TOTPSetupQrCodeImageUrl: string
}

export class DialogSYSLoginForm extends SYSFormElement {
  loginActions: typeof SYSLogin
  async init() {
    this.loginActions = (<any>this.actions.app.features).SYSLogin
    this.formType = "SYSLogin"

    await super.init()
  }
  getBody = () => {
    let fields = this.formState.fields
    let userField = fields["user"]
    let pwField = fields["pw"]
    let pwBox = html`
      <div class="fd-form-item">
        <ovl-textbox .props=${() => pwField}> </ovl-textbox>
      </div>
    `

    let hideForgotPassword = "ovl-hideControl"
    if (
      !ProcessIsRunning("SYSLoginLogin") &&
      FieldIsValidSelective(userField, {
        ignoreValidationKeys: ["SYSLoginValidationInvalidPassword"],
      })
    ) {
      hideForgotPassword = ""
    }

    let handleForgotPw = (e: Event) => {
      e.preventDefault()
      e.stopPropagation()
      this.loginActions.actions.ForgotPw(this.formState)
    }

    return html`
      <form class="fd-form__group ovl-maxwidth-60ch ovl-pt-sm">
        <div class="fd-form-item">
          <ovl-textbox .props=${() => userField}> </ovl-textbox>
        </div>

        ${pwBox}
        <ovl-passwordvisibility></ovl-passwordvisibility>
        <ovl-formvalidationhint
          .props=${() => this.formState}
        ></ovl-formvalidationhint>
        <a
          @click=${handleForgotPw}
          href="#"
          class=${`fd-link ${hideForgotPassword}`}
          >${T("SYSLoginForgotPassword")}</a
        >
      </form>
    `
  }
  getFooter = () => {
    let handleLogin = async () => {
      let res: any = await this.loginActions.actions.Login({
        formState: this.formState,
      })
    }
    return html`<button
      @click=${handleLogin}
      class="fd-dialog__decisive-button fd-button"
      id="ovlloginbutton"
      ?disabled=${FormIsLocked(this.formState) ||
      !FieldIsValid(this.formState.fields.pw) ||
      !FieldIsValid(this.formState.fields.user) ||
      ProcessIsRunning("SYSLoginLogin")}
    >
      ${T("SYSLoginLogin")}
    </button> `
  }

  async getUI() {
    let handleKey = async (e: KeyboardEvent) => {
      if ((<HTMLElement>e.target).tagName !== "A" && e.key == "Enter") {
        e.preventDefault()
        e.stopPropagation()
        document.getElementById("ovlloginbutton").focus()
        let res: any = await this.loginActions.actions.Login({
          formState: this.formState,
        })
      }
    }
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        type: () => "information",
        title: () => T("SYSLoginPleaseLogin"),
        body: () => this.getBody(),
        footer: () => this.getFooter(),
        keyHandlerFn: handleKey,
      },

      dialogType: "SYSLogin",
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
